// React
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injections
import { notifyError } from '../../containers/componentsInjection';
import { ReportsInjection } from '../../containers/reportsInjection';

// View
import { EnvelopePrintPage } from './view';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import { APIClient } from '../../../../helpers/api_helper';
import { openPdfWithBase64 } from '../../../../utils/openPdfWithBase64';

export const EnvelopePrint = () => {
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState({
    cpfInput: '',
    proposal: '',
  });

  const [customerSelected, setCustomerSelected] = useState({});
  const [isOpenModal, setIsOpenModal] = useState();

  const { getOrderAssociates, associates, success } = ReportsInjection();

  const api = new APIClient();
  const history = useHistory();
  const { toggleLoading, setLoading } = useLoading();

  const handleSearch = async (event) => {
    toggleLoading();
    setSearch(event);
    await getOrderAssociates({
      page: 1,
      length: 10,
      search: event,
      order_column: 1,
      order_dir: 'asc',
    });

    setTimeout(() => {
      setShow(true);
      setLoading(false);
    }, 1000);
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      cpfInput: '',
      proposal: '',
    },
    validationSchema: Yup.object({
      cpfInput: Yup.string(),
      proposal: Yup.string(),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        cpf: values.cpfInput || null,
        proposal_id: values.proposal || null,
        name: null,
        status_id: null,
      };
      handleSearch(valuesToSubmit);
    },
  });

  const handleGenerateReport = (param) => {
    toggleLoading();
    api
      .create('/reports/card/envelope', { proposal_id: param })
      .then((response) => {
        openPdfWithBase64(response.data, 'Impressão de Envelopes');
      })
      .catch((error) => {
        notifyError(error.response.data.messages.error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <EnvelopePrintPage
      show={show}
      history={history}
      validation={validation}
      // Data
      isOpen={isOpenModal}
      search={search}
      setSearch={setSearch}
      associates={associates?.data}
      customerSelected={customerSelected}
      setCustomerSelected={setCustomerSelected}
      handleGenerateReport={handleGenerateReport}
      toggle={() => setIsOpenModal((prevState) => !prevState)}
    />
  );
};
